import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  className = '', 
  loading = false, 
  fullWidth = false, 
  onClick,
  type = "button",
  ...props 
}) => {
  const variantClass = variant === 'primary' ? 'premium-button-primary' : 'premium-button-secondary';
  const widthClass = fullWidth ? 'w-full' : '';
  
  // Ensure invalid DOM props are not passed to the button element
  const { 
    active,
    icon,
    helperText,
    fullWidth: _fullWidth,
    variant: _variant,
    loading: _loading,
    ...validProps 
  } = props;

  return (
    <button 
      type={type}
      onClick={onClick}
      className={`premium-button ${variantClass} ${widthClass} ${className} ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}
      disabled={loading || validProps.disabled}
      aria-busy={loading}
      {...validProps}
    >
      {loading ? (
        <span className="flex items-center justify-center">
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Processing...
        </span>
      ) : children}
    </button>
  );
};

export default Button;
